import { createSlice } from '@reduxjs/toolkit';
import { ProductHierarchyEdge, ProductHierarchyNode, ProductHierarchyState, ProductHierarcyEdge } from '../../../types'


const initialState: ProductHierarchyEdge | undefined = {
    edges: []
}

const productHierarchyListSlice = createSlice({
    name: 'productHierarchySlicer',
    initialState,
    reducers: {
        setProductHierarchies(state, action: { payload: ProductHierarchyEdge }) {
           
            state.edges =action.payload.edges;

        },
        deleteProductHierarchy(state, action: { payload: [] | undefined }) {
            let customEdge: ProductHierarchyEdge | undefined = { edges: [{ node: { displayName: '', documentRelations: [], guid: "9", productHierarchyCode: "", rank: 0, subProductHierarchies: [],parentHierarchy:null } }] }
            state.edges = customEdge.edges;
        }
    }
});

export const {
    setProductHierarchies,
    deleteProductHierarchy
} = productHierarchyListSlice.actions;

export default productHierarchyListSlice.reducer;